import { Node as DeliveryNode } from 'contensis-delivery-api';
import { Node as ManagementNode } from 'contensis-management-api';
import mapJson from 'jsonpath-mapper';
import { NodesResult } from '~/models';
import EntriesMigrationService from '~/services/EntriesMigrationService';
import NodesMigrationService from '~/services/NodesMigrationService';
import { dedupeInner } from '~/util/array';

export const mapNodesMigrateResult = (
  service: NodesMigrationService | EntriesMigrationService
) => {
  const { sourceRepo, targetRepos } = service;
  const result = {
    nodes:
      sourceRepo.projectId && sourceRepo.projectId !== 'null'
        ? { [sourceRepo.projectId]: { totalCount: 0 } }
        : undefined,
    errors: Object.keys(service.errors).length
      ? dedupeInner(Object.values(service.errors).flat())
      : undefined,
    nodesResult: !service.isPreview
      ? {
          created: service.nodesMigration.created.length,
          updated: service.nodesMigration.updated.length,
          deleted: service.nodesMigration.deleted.length,
          errors: Object.values(service.errors).flat().length || undefined,
        }
      : undefined,
    existing: Object.fromEntries(
      Object.keys(targetRepos).map((projectId) => [
        projectId,
        { totalCount: 0 },
      ])
    ),
    nodesToMigrate: Object.fromEntries(
      Object.keys(targetRepos).map((projectId) => [projectId, {}])
    ),
  } as NodesResult;

  for (const [projectId, target] of Object.entries(targetRepos)) {
    result.existing[projectId] = {
      totalCount: target.nodes.totalCount,
      nodes: mapNodesForResponse(target.nodes.raw),
    };

    const statuses = [
      ...new Set(target.nodes.migrateNodes.map((mn) => mn.status)),
    ];
    result.nodesToMigrate.nodeIds = Object.fromEntries(
      target.nodes.migrateNodes.map((mn, idx) => [
        mn.originalId || mn.id || `[${idx}]`,
        {
          path: mn.path,
          displayName: mn.displayName,
          id: mn.id,
          parentId: mn.parentId,
          entryId: mn.entryId,
          diff: mn.status === 'update' ? mn.diff : undefined,
          status: mn.status,
          error: mn.error,
        },
      ])
    );
    result.nodesToMigrate[projectId] = Object.fromEntries([
      ...statuses.map((status) => [
        status,
        target.nodes.migrateNodes.filter((mn) => mn.status === status).length,
      ]),
      [
        'totalCount',
        target.nodes.migrateNodes?.filter((e) =>
          ['create', 'two-pass', 'update', 'delete'].includes(e.status)
        )?.length || 0,
      ],
    ]);
  }
  if (result.nodes) {
    result.nodes[sourceRepo.projectId] = {
      totalCount: sourceRepo.nodes.totalCount,
      // paths: this.MapNodesForResponse(sourceRepo.nodes.raw).map((n) => n.path),
    };
  }

  return result;
};

const mapNodesForResponse = (
  nodes: DeliveryNode[]
): (DeliveryNode & ManagementNode)[] =>
  nodes.map((node) =>
    mapJson(node, {
      childCount: { $path: 'childCount', $disable: (c) => !c },
      contentTypeId: 'entry.sys.contentTypeId',
      displayName: 'displayName',
      entryId: 'entry.sys.id',
      id: 'id',
      parentId: 'parentId',
      path: 'path',
    })
  );
